// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    name: 'dev',
    clientId: '1ad5dc80-a72c-4703-a42c-fe5661a57caf',
    authority:
        'https://login.microsoftonline.com/a3fa8e74-b14d-4758-a49c-931f83606b14',
    redirectUri: '/dispatcher',
    postLogoutRedirectUri: '/',
    scopes: ['user.read'],
    apiUrl: 'https://localhost:44300'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
